import React from 'react';

const TagUsuario = (props) => {
    return (
        <li className="bottom-separator-xxs">
            <div className="btn-group">
                <button type="button" className="btn-tag btn-tag-big btn-tag-closable btn-tag-closable-left not-clickable">{props.loginName}</button>
                <button type="button" className="btn-tag btn-tag-big btn-tag-closable btn-tag-closable-right"
                    onClick={() => props.deleteUsuario(props.loginName)}>
                    <span key={props.key} className="ti-close span-closable" title="Quitar usuario."></span>
                </button>
            </div>
        </li>
    );
}

export default TagUsuario;